export const STATUS_META = {
  rented: {
    label: "Rented Out",
    badge: "bg-emerald-50 text-emerald-700 border-emerald-200",
    dot: "bg-emerald-500",
  },
  owner_occupied: {
    label: "Owner Occupied",
    badge: "bg-blue-50 text-blue-700 border-blue-200",
    dot: "bg-blue-500",
  },
  vacant: {
    label: "Vacant",
    badge: "bg-amber-50 text-amber-700 border-amber-200",
    dot: "bg-amber-500",
  },
};

export const formatCurrency = (v) => {
  if (v == null) return "—";
  return "₹" + Number(v).toLocaleString("en-IN");
};

export const formatDate = (d) => {
  if (!d) return "—";
  try {
    return new Date(d).toLocaleDateString("en-IN", { day: "2-digit", month: "short", year: "numeric" });
  } catch {
    return d;
  }
};
